import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/images/for-her/image-1.png";
import img2 from "../assets/images/for-her/image-2.png";
import img3 from "../assets/images/for-her/image-3.png";
import img4 from "../assets/images/for-her/image-4.png";
import img5 from "../assets/images/for-her/image-5.png";
import img6 from "../assets/images/for-her/image-6.png";
import "../assets/css/collection-page.css";

const PRODUCTS = [
  { src: img4, title: "Rose Éternelle",    type: "Eau de Parfum · 50 ml"   },
  { src: img2, title: "Blossom Silk",      type: "Eau de Toilette · 75 ml" },
  { src: img3, title: "Velvet Jasmine",    type: "Parfum Extrait · 50 ml"  },
  { src: img1, title: "Pearl Musk",        type: "Eau de Parfum · 100 ml"  },
  { src: img5, title: "Chérie Fleurie",    type: "Eau de Toilette · 100 ml"},
  { src: img6, title: "Amber Bloom",       type: "Parfum Extrait · 75 ml"  },
];

const ForHer = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      {/* ── HERO BANNER ── */}
      <section className="cp-hero cp-hero--her">
        {/* Left — text panel */}
        <div className="cp-hero-text-panel cp-hero-text-panel--left">
          <div className="cp-hero-text-inner">
            <span className="cp-hero-eyebrow">Pour Elle · Perfume Paris</span>

            <h1 className="cp-hero-title">
              Grace.<br />
              <em>Sensuality.<br />Elegance.</em>
            </h1>

            <div className="cp-hero-divider" />

            <p className="cp-hero-desc">
              Delicate florals, warm orientals, and timeless musks —
              each fragrance is a love letter to femininity. Discover the
              scent that becomes uniquely yours.
            </p>

            <ul className="cp-hero-tags">
              <li>Floral &amp; Fresh</li>
              <li>Oriental &amp; Warm</li>
              <li>Musky &amp; Sensual</li>
            </ul>

            <div className="cp-hero-actions">
              <a href="#collection" className="cp-btn-primary">Explore Collection</a>
              <Link to="/shop" className="cp-btn-ghost">View All</Link>
            </div>
          </div>
        </div>

        {/* Right — image panel */}
        <div className="cp-hero-img-panel">
          <img src={img1} alt="For Her" className="cp-hero-img" />
          <div className="cp-hero-img-overlay cp-hero-img-overlay--her" />

          {/* floating accent card */}
          <div className="cp-hero-badge cp-hero-badge--her">
            <span className="cp-hero-badge-num">6</span>
            <span className="cp-hero-badge-label">Exclusive<br />Fragrances</span>
          </div>
        </div>
      </section>

      {/* ── COLLECTION GRID ── */}
      <section id="collection" className="cp-grid-section cp-grid-section--her">
        <div className="container">
          <div className="cp-grid-header">
            <span className="cp-grid-tag">Women's Collection</span>
            <h2 className="cp-grid-title">Exclusive <em>Fragrances</em></h2>
            <div className="cp-grid-line" />
            <p className="cp-grid-sub">
              Discover our signature fragrances crafted for her — a perfect blend of
              elegance, beauty, and allure in every drop.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {PRODUCTS.map((p, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4">
                <div className="cp-card cp-card--her">
                  <div className="cp-card-img-wrap">
                    <img src={p.src} alt={p.title} className="cp-card-img" />
                    <div className="cp-card-overlay">
                      <Link to="/shop" className="cp-card-cta">View Details</Link>
                    </div>
                  </div>
                  <div className="cp-card-body">
                    <h3 className="cp-card-name">{p.title}</h3>
                    <p className="cp-card-type">{p.type}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ForHer;
